class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.querySelector('summary');
    this.hoverTimeout = null;
    this.isMegaMenu = this.classList.contains('mega-menu');
    
    // Add hover events for desktop
    this.setupHoverEvents();
  }

  setupHoverEvents() {
    // Only enable hover on desktop (screens 990px and wider)
    const mediaQuery = window.matchMedia('(min-width: 990px)');
    
    // Store bound functions to properly remove event listeners
    this.onMouseEnterBound = this.onMouseEnter.bind(this);
    this.onMouseLeaveBound = this.onMouseLeave.bind(this);
    this.onDesktopClickBound = this.onDesktopClick.bind(this);
    
    const handleHover = () => {
      if (mediaQuery.matches) {
        // Desktop: use hover
        this.addEventListener('mouseenter', this.onMouseEnterBound);
        this.addEventListener('mouseleave', this.onMouseLeaveBound);
        // Prevent click on desktop when hover is active
        this.summary.addEventListener('click', this.onDesktopClickBound);
      } else {
        // Mobile: remove hover listeners and allow normal click behavior
        this.removeEventListener('mouseenter', this.onMouseEnterBound);
        this.removeEventListener('mouseleave', this.onMouseLeaveBound);
        this.summary.removeEventListener('click', this.onDesktopClickBound);
      }
    };

    // Initial setup
    handleHover();
    
    // Listen for media query changes
    mediaQuery.addEventListener('change', handleHover);
  }

  onDesktopClick(event) {
    // Prevent default click behavior on desktop when using hover
    if (window.matchMedia('(min-width: 990px)').matches) {
      event.preventDefault();
    }
  }

  onMouseEnter() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    
    // Small delay to prevent accidental triggers
    this.hoverTimeout = setTimeout(() => {
      this.open();
      this.setAttribute('data-hover-open', '');
    }, 100);
  }

  onMouseLeave() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    
    // Delay closing to allow moving to submenu
    this.hoverTimeout = setTimeout(() => {
      this.close();
      this.removeAttribute('data-hover-open');
    }, 150);
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
